import dateHelper from '../dateHelper';

function compareStr(a, b) {
    if (a > b) {
        return 1;
    } else if (a < b) {
        return -1;
    } else {
        return 0;
    }
}

function compareByName(a, b) {
    return compareStr(a.name, b.name);
}
function compareByDate(a, b) {
    return -dateHelper.compare(a.createdOn, b.createdOn);
}
function compareByType(a, b) {
    return compareStr(a.type,b.type);
}
function compareByAuthor(a, b) {
    return compareStr(a.author, b.author);
}
function compareBySize(a, b) {
    return a.size - b.size;
}

export default function SortChildren(orderCriteria,children) {
    const result = [];
    const files = [];
    children.forEach(child => {
        if (child.hasChildren) {
            result.push(child);
        } else {
            files.push(child);
        }
    })

    var compareMethod = null;
    if (orderCriteria === 'Upload Date') {
        compareMethod = compareByDate;
    } else if (orderCriteria === 'Name') {
        compareMethod = compareByName;
    } else if (orderCriteria === 'Size') {
        compareMethod = compareBySize;
    } else if (orderCriteria === 'Author') {
        compareMethod = compareByAuthor;
    } else if (orderCriteria === 'Type') {
        compareMethod = compareByType;
    }

    if (compareMethod) {
        files.sort(compareMethod);
    }
    files.forEach(file => {
        result.push(file);
    })

    return result;
}